import {
    FilterableMailBoxUrlSlugs,
    FilterableMessageCentreUrlSlugs,
} from "@twigsby/client-data";
import {GenericFilterEntryType} from "@twigsby/client-data/lib/Types/GenericTypes";
import {GetArrayIndexByKeyValue} from "@twigsby/helpers";
import {FormatIsoDateTime} from "@twigsby/helpers/lib/Date";
import {enGB} from "date-fns/locale";
import {Location} from "react-router-dom";
import {MailboxUrlParamsType} from "./MailUrlMapping";

type GenericUrlSlugsType = {
    [key:string]: GenericFilterEntryType;
}

const BuildUrlFilterFromParams = (props: MailboxUrlParamsType, location: Location, name: string, data?: any, isArray?: boolean, overrideValue?: any): GenericUrlSlugsType => {
    const newValue = location.state && location.state[name] !== undefined ? location.state[name] : props[name];
    const friendlyValue = location.state && location.state[`${name}Friendly`] ? location.state[`${name}Friendly`] : undefined;

    if(newValue === null || newValue === undefined) {
        return {}
    }

    return {
        [name]: {
            value: overrideValue ? overrideValue : isArray ? [newValue] : newValue,
            friendlyValue: friendlyValue ? friendlyValue : data ? data[GetArrayIndexByKeyValue(data, 'value', newValue)].label : null
        }
    }
}

const UpdateSingleFilter = (
    existingFilters: FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs,
    filterName:  keyof FilterableMailBoxUrlSlugs | keyof FilterableMessageCentreUrlSlugs,
    filterValue: any,
    filterFriendlyValue?: string
) => {
    if(filterValue === null || filterValue === undefined || filterValue === -1) {
        const newFilters = { ...existingFilters };

        delete newFilters[filterName];

        return newFilters;
    }

    return {
        ...existingFilters,
        [filterName]: { value: filterValue, friendlyValue: filterFriendlyValue }
    }
}

const UpdateAllFilters = (existingFilters: FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs) : FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs => {
    let newFilters = JSON.parse(JSON.stringify(existingFilters));

    if(newFilters['startDate']?.value) {
        newFilters['startDate'].value = FormatIsoDateTime(newFilters['startDate'].value as Date, enGB);
    }

    if(newFilters['endDate']?.value) {
        newFilters['endDate'].value = FormatIsoDateTime(newFilters['endDate'].value as Date, enGB);
    }

    return newFilters
}

const DeleteFilter = (existingFilters: FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs, filterName: keyof GenericUrlSlugsType) : FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs => {
    let newFilters: FilterableMailBoxUrlSlugs | FilterableMessageCentreUrlSlugs = JSON.parse(JSON.stringify(existingFilters));

    delete newFilters[filterName];

    return newFilters
}

export {
    BuildUrlFilterFromParams,
    UpdateSingleFilter,
    DeleteFilter,
    UpdateAllFilters
}
